// @ts-expect-error not typed
import { isCloseThreadMessage } from 'conversations-message-history/thread-status-update/operators/isCloseThreadMessage';
// @ts-expect-error not typed
import { isOpenThreadMessage } from 'conversations-message-history/thread-status-update/operators/isOpenThreadMessage';
// @ts-expect-error not typed
import { isContactAssociationMessage } from 'conversations-message-history/contact-association-message/operators/isContactAssociationMessage';
import { isTypingMessage } from 'conversations-message-history/typing-indicator/operators/isTypingMessage';
// @ts-expect-error not typed
import { isCrmObjectLifecycleUpdate } from 'conversations-message-history/crm-object-lifecycle-update/operators/isCrmObjectLifecycleUpdate';
// @ts-expect-error not typed
import { isCommonMessageFormat } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import { deserialize } from 'conversations-message-history/common-message/serializers/messageSerializer';
import { assignmentV2MessageReceived } from '../../actions/assignmentV2MessageReceived';
import { clearTypingOnHandoff } from '../../typing-indicators/actions/clearTypingOnHandoff';
import { defaultMessageReceived } from '../../actions/defaultMessageReceived';
// @ts-expect-error not typed
import { resolveAttachmentsForMessage } from '../../resolved-attachments/actions/resolveAttachmentsForMessage';
import { getThreadByThreadId } from '../../threads/selectors/getThreadByThreadId';
// @ts-expect-error not typed
import { dismissTypingIndicator } from '../../typing-indicators/actions/dismissTypingIndicator';
// @ts-expect-error not typed
import { typingMessageReceived } from '../../typing-indicators/actions/typingMessageReceived';
// @ts-expect-error not typed
import { closeThreadMessageReceived } from './closeThreadMessageReceived';
import { openThreadMessageReceived } from './openThreadMessageReceived';
// @ts-expect-error not typed
import { channelChangeReceived } from './changeChannelReceived';
import { genericChannelChangeReceived } from './genericChannelChangeReceived';
import { ChannelChange, CHANNEL_CHANGE } from 'conversations-internal-pub-sub/channel-change/records/ChannelChange';
// @ts-expect-error not typed
import { getType } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { hasLlmSender } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
// @ts-expect-error not typed
import { onContactAssociated } from './onContactAssociated';
// @ts-expect-error not typed
import { validateMessageClientType } from '../util/validateMessageClientType';
// @ts-expect-error not typed
import { isAssignmentUpdateMessage } from 'conversations-message-history/assignment-update-message/operators/isAssignmentUpdateMessage';
import { isPartialMessage } from 'conversations-message-history/partial-message/operators/isPartialMessage';
import { partialMessageReceived } from './partialMessageReceived';
import { rejectedMessageReceived } from './rejectedMessageReceived';
import { isRejectedMessage } from 'conversations-message-history/message-rejected/operators/isRejectedMessage';
import { trackLlmMessageReceived } from './trackLlmMessageReceived';
import Raven from 'raven-js';
export const onMessageReceived = ({
  threadId,
  message: pubSubMessage,
  channel,
  publishContext = {}
}) => (dispatch, getState) => {
  const {
    data: messageJson,
    clientId
  } = pubSubMessage;
  const thread = getThreadByThreadId(getState(), {
    threadId
  });

  // TODO: Remove this hardcoded string and move it to a shared constant
  if (getType(messageJson) === 'GENERIC_CHANNEL_CHANGE' || getType(messageJson) === 'THREAD_PAUSED_ON_GENERIC_CHANNEL' && messageJson.isPausedOn === 1000) {
    dispatch(genericChannelChangeReceived({
      threadId
    }));
    return;
  }
  if (getType(messageJson) === CHANNEL_CHANGE) {
    dispatch(channelChangeReceived({
      channelChange: new ChannelChange(messageJson),
      threadId
    }));
    return;
  }
  const message = deserialize({
    json: messageJson
  });
  validateMessageClientType({
    message,
    clientId
  });
  switch (true) {
    case isPartialMessage(message):
      {
        dispatch(dismissTypingIndicator(message, threadId));
        dispatch(partialMessageReceived({
          message,
          channel,
          threadId,
          publishContext
        }));
        break;
      }
    case isCrmObjectLifecycleUpdate(message):
      {
        // NOOP
        break;
      }
    case isCommonMessageFormat(message):
      {
        dispatch(dismissTypingIndicator(message, threadId));
        dispatch(defaultMessageReceived(message, channel, threadId, publishContext));
        dispatch(resolveAttachmentsForMessage({
          message,
          threadId
        }));
        if (hasLlmSender(message) && !(publishContext !== null && publishContext !== void 0 && publishContext.playback)) {
          dispatch(trackLlmMessageReceived({
            message,
            threadId
          }));
        }
        break;
      }
    case isAssignmentUpdateMessage(message):
      {
        dispatch(clearTypingOnHandoff(message, threadId));
        dispatch(assignmentV2MessageReceived(message, channel, threadId));
        break;
      }
    case isContactAssociationMessage(message):
      {
        onContactAssociated();
        break;
      }
    case isTypingMessage(message):
      {
        if (!publishContext.playback) dispatch(typingMessageReceived(message, threadId));
        break;
      }
    case isRejectedMessage(message):
      {
        dispatch(rejectedMessageReceived({
          message,
          channel,
          threadId
        }));
        break;
      }
    case isCloseThreadMessage(message):
      {
        Raven.captureMessage('close-thread-message-received', {
          level: 'info',
          extra: {
            threadId,
            channel
          }
        });
        dispatch(closeThreadMessageReceived({
          message,
          thread,
          channel
        }));
        break;
      }
    case isOpenThreadMessage(message):
      {
        dispatch(openThreadMessageReceived({
          message,
          channel,
          threadId
        }));
        break;
      }
    default:
      {
        dispatch(defaultMessageReceived(message, channel, threadId, publishContext));
      }
  }
};